module.exports = __webpack_public_path__ + "img/rev-share.bfd6406b.svg";